import { BehaviorSubject, Subject } from 'rxjs';

import { type TokenV2Metadata } from '@app/client';

// The Main Subject/Stream to be listened on.
export const mainSubject = new Subject();

export const glUpdateFacesSubject = new BehaviorSubject<{
    lidID: string;
    isCancel: boolean;
    items: TokenV2Metadata[];
}>({
    lidID: '',
    isCancel: false,
    items: Array(6).fill(undefined),
});

export const glLiquidIDFaceHoveredSubject = new BehaviorSubject<number | undefined>(undefined);
